module.exports = function() {
  return new Worker(__webpack_public_path__ + "93f1a1e55fb6e671ac77.worker.js");
};